var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8035 1.91051C2.46931 1.2447 3.41394 0.893768 4.33721 1.0324C5.16914 1.15732 5.959 1.67566 6.50002 2.66799C7.04103 1.67566 7.83089 1.15732 8.66283 1.0324C9.5861 0.893768 10.5307 1.2447 11.1965 1.91051C11.898 2.61199 12.1093 3.5858 12.0474 4.50045C11.9855 5.41353 11.6501 6.30151 11.213 6.86388C10.3884 7.92498 10.0945 8.23806 9.34838 8.96557C8.97374 9.33084 8.4879 9.75737 8.09779 10.091C7.9023 10.2581 7.73005 10.4027 7.60664 10.5054C7.54492 10.5568 7.4954 10.5978 7.46126 10.6259L7.42198 10.6582L7.41567 10.6634C7.16177 10.9134 6.83057 11.0385 6.50002 11.0385C6.16946 11.0385 5.83826 10.9134 5.58436 10.6634L5.57805 10.6582L5.53877 10.6259C5.50463 10.5978 5.45511 10.5568 5.39339 10.5054C5.26998 10.4027 5.09773 10.2581 4.90225 10.091C4.51213 9.75737 4.02629 9.33084 3.65166 8.96557C2.90551 8.23806 2.61163 7.92498 1.787 6.86388C1.34996 6.30151 1.01449 5.41353 0.952673 4.50045C0.890754 3.5858 1.10203 2.61199 1.8035 1.91051Z",
    fill: "#B5B5B5",
    stroke: "#B5B5B5",
    strokeWidth: 1.27646,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.b8484ee47cb39a061453485c9d92c358.svg";
export { ForwardRef as ReactComponent };